import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* istanbul ignore file */
import { useQuery } from '@tanstack/react-query';
import getWebShellProductOptions from './get-options';
var useFetchWebShellProduct = function useFetchWebShellProduct() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    productCode = _ref.productCode,
    select = _ref.select;
  return useQuery(_objectSpread(_objectSpread({}, getWebShellProductOptions({
    productCode: productCode
  })), select && {
    select: select
  }));
};
export default useFetchWebShellProduct;